export const adlFilterTypes = [
  {
    id: false,
    value: "All",
  },
  {
    id: "c4f54feb-4471-41eb-a961-cf7d8095f925",
    value: "Activities",
  },
  {
    id: "53deb499-d582-44d6-8bc7-07fc013d5129",
    value: "Communication",
  },
  {
    id: "8797fa44-6e31-4897-95e3-40d17037eae5",
    value: "Complex healthcare",
  },
  {
    id: "0309512b-0e3a-48d3-bf0c-c373faf5791a",
    value: "Death and dying",
  },
  {
    id: "78af6629-ca9a-4401-8f4a-74a89bbe55a9",
    value: "Emotional support",
  },
  {
    id: "3fafdf26-37be-4176-8a6c-dc76dc64cafa",
    value: "Medical",
  },
  {
    id: "5d0e4042-f15b-4f26-acb0-b67d0345177a",
    value: "Nutrition eating and drinking",
  },
  {
    id: "e97b931e-1dfe-4225-827b-eac90ea916e5",
    value: "Personal care",
  },
  {
    id: "6991085b-ca92-4493-a7b0-9800bcf11147",
    value: "Personal safety and environment",
  },
  {
    id: "346632fe-46ed-4f7d-bcad-e0c874ecadd5",
    value: "Processes",
  },
  {
    id: "b553b832-5f35-4637-9750-f819a819ba87",
    value: "Sleeping",
  },
  {
    id: "8e8ed519-257b-4d41-91e8-2488867b32f5",
    value: "Toileting",
  },
];

export const searchFilterTypes = [
  {
    id: 1,
    value: "All",
  },
  {
    id: 2,
    value: "Shift handover only",
  },
  {
    id: 3,
    value: "GP/Nurse/Specialist etc",
  },
  {
    id: 4,
    value: "Continence",
  },
  {
    id: 5,
    value: "Complaints and compliments",
  },
];

export const aspectOfLifeNameToFontAwesomeIcon = {
  Activities: "futbol",
  Communication: "comments",
  "Complex healthcare": "medkit",
  "Death and dying": "procedures",
  "Emotional support": "heartbeat",
  Medical: "stethoscope",
  Mobility: "hiking",
  "Nutrition eating and drinking": "utensils",
  "Personal care": "user-nurse",
  "Personal safety and environment": "shield-alt",
  Processes: "cog",
  Sleeping: "bed",
  Toileting: "toilet",
};

export const actionIconIds = [
  {
    ActionIconID: 1,
    FullTitle: "Newspaper",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 2,
    FullTitle: "Chat",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 3,
    FullTitle: "Email",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 4,
    FullTitle: "Write letter",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 5,
    FullTitle: "Read letter",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 6,
    FullTitle: "Writing",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 7,
    FullTitle: "Speaking",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 8,
    FullTitle: "Reading",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 9,
    FullTitle: "Unable to communicate",
    ExpectedDuration: 15,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 10,
    FullTitle: "Telephone call",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 11,
    FullTitle: "Mentoring",
    ExpectedDuration: 30,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 99,
    FullTitle: "Other",
    ExpectedDuration: 15,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 1001,
    FullTitle: "Open bowels",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1002,
    FullTitle: "Loose bowels",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1003,
    FullTitle: "Help with toilet",
    ExpectedDuration: 30,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1004,
    FullTitle: "Clothes wet",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1005,
    FullTitle: "Clothes soiled",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1006,
    FullTitle: "Pad checked",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1007,
    FullTitle: "Bed pan",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1008,
    FullTitle: "Commode",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1009,
    FullTitle: "Urinate",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1010,
    FullTitle: "Urine bottle",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 1099,
    FullTitle: "Other",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 2001,
    FullTitle: "Stayed in room",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2002,
    FullTitle: "Take to room",
    ExpectedDuration: 5,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2003,
    FullTitle: "Armchair exercises",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2004,
    FullTitle: "Indoor skittles",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2005,
    FullTitle: "Entertainer",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2006,
    FullTitle: "Concert",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2007,
    FullTitle: "Did crossword",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2008,
    FullTitle: "Walk",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2009,
    FullTitle: "Visit relative",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2010,
    FullTitle: "Go to the pub",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2011,
    FullTitle: "Church",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2012,
    FullTitle: "TV",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2013,
    FullTitle: "Music",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2014,
    FullTitle: "Film",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2015,
    FullTitle: "Game",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2016,
    FullTitle: "Quiz",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2017,
    FullTitle: "Arts & Crafts",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2018,
    FullTitle: "Take to sitting room",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2019,
    FullTitle: "Reading",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2020,
    FullTitle: "Knitting",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2021,
    FullTitle: "Go to a Fete",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2022,
    FullTitle: "BBQ",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2023,
    FullTitle: "Shopping",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2024,
    FullTitle: "Outing",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2025,
    FullTitle: "Day centre",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2026,
    FullTitle: "Birthday party",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2027,
    FullTitle: "Party",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2028,
    FullTitle: "Used computer",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2029,
    FullTitle: "Go to the cinema",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2030,
    FullTitle: "Go to the theatre",
    ExpectedDuration: 60,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2031,
    FullTitle: "Gardening",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2032,
    FullTitle: "Pets",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2033,
    FullTitle: "Had a visitor",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2034,
    FullTitle: "Bingo",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2035,
    FullTitle: "Goal/Achievement",
    ExpectedDuration: 5,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2036,
    FullTitle: "Swimming",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2037,
    FullTitle: "Horse riding",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2038,
    FullTitle: "Cooking",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2039,
    FullTitle: "Games console",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2040,
    FullTitle: "Massage",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2041,
    FullTitle: "Body Coach Session",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2042,
    FullTitle: "Bowling",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2043,
    FullTitle: "Ball games",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2044,
    FullTitle: "Relaxation",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2045,
    FullTitle: "Drama",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2046,
    FullTitle: "Housework",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2047,
    FullTitle: "Schedule",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2048,
    FullTitle: "Cigarette",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2049,
    FullTitle: "Drive",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2050,
    FullTitle: "Singing",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2051,
    FullTitle: "Dominoes",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2052,
    FullTitle: "Reminisce",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2053,
    FullTitle: "Community",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2054,
    FullTitle: "Sensory",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2088,
    FullTitle: "Therapeutics",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2089,
    FullTitle: "ReMe",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2090,
    FullTitle: "Oomph! Calendar",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2091,
    FullTitle: "Oomph! Explorer",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2092,
    FullTitle: "Oomph! Digest",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2093,
    FullTitle: "Oomph! Exercise",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2094,
    FullTitle: "Oomph! Wireless",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 2099,
    FullTitle: "Other",
    ExpectedDuration: 30,
    AspectOfLifeName: "Activities",
  },
  {
    ActionIconID: 4001,
    FullTitle: "Medication",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4002,
    FullTitle: "PRN medication",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4003,
    FullTitle: "Call Doctor",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4004,
    FullTitle: "Call Ambulance",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4005,
    FullTitle: "Doctor",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4006,
    FullTitle: "Nurse",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4007,
    FullTitle: "Professional",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4008,
    FullTitle: "Sick",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4009,
    FullTitle: "Dress wound",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4010,
    FullTitle: "New catheter",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4011,
    FullTitle: "PEG Feed",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4012,
    FullTitle: "Stoma",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4013,
    FullTitle: "Enema",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4014,
    FullTitle: "Sample",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4015,
    FullTitle: "Bladder washout",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4016,
    FullTitle: "Add catheter bag",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4017,
    FullTitle: "Catheter bag emptied",
    ExpectedDuration: 15,
    AspectOfLifeName: "Toileting",
  },
  {
    ActionIconID: 4018,
    FullTitle: "Catheter bag changed",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4019,
    FullTitle: "Cream",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4020,
    FullTitle: "Skin",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4021,
    FullTitle: "Blood pressure",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4022,
    FullTitle: "Pulse",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4023,
    FullTitle: "Respiration",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4024,
    FullTitle: "Temperature",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4025,
    FullTitle: "Blood O2",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4027,
    FullTitle: "Insulin",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4028,
    FullTitle: "Seizure",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4029,
    FullTitle: "Tracheostomy",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4030,
    FullTitle: "Suction",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4031,
    FullTitle: "Hospital",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4032,
    FullTitle: "Clinic",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4033,
    FullTitle: "IV line flush",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4034,
    FullTitle: "Multistix",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4035,
    FullTitle: "Ear syringe",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4036,
    FullTitle: "In pain",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4037,
    FullTitle: "Blood INR",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4038,
    FullTitle: "Compression garment",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4039,
    FullTitle: "Foot splint",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4040,
    FullTitle: "Hand splint",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4041,
    FullTitle: "Qualified Specialist",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4042,
    FullTitle: "Blood test",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4043,
    FullTitle: "Oxygen level",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4044,
    FullTitle: "Heat pack",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4045,
    FullTitle: "Consciousness",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4046,
    FullTitle: "PainAssessment",
    ExpectedDuration: 2,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4047,
    FullTitle: "Neuro Obs.",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4048,
    FullTitle: "Restraint",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4049,
    FullTitle: "Coronavirus symptom check",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4050,
    FullTitle: "Soft signs check",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4051,
    FullTitle: "Positive airway pressure therapy",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 4099,
    FullTitle: "Other",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 5001,
    FullTitle: "Agitated",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5002,
    FullTitle: "Confused",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5003,
    FullTitle: "Challenging behaviour",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5004,
    FullTitle: "Pacing",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5005,
    FullTitle: "Upset or crying",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5006,
    FullTitle: "Social worker",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5007,
    FullTitle: "Repetitive behaviour",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5008,
    FullTitle: "Paranoid behaviour",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5009,
    FullTitle: "Hallucinated",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5010,
    FullTitle: "Disinhibited behaviour",
    ExpectedDuration: 30,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5011,
    FullTitle: "Wandering",
    ExpectedDuration: 15,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 5099,
    FullTitle: "Emotional support",
    ExpectedDuration: 15,
    AspectOfLifeName: "Emotional support",
  },
  {
    ActionIconID: 6001,
    FullTitle: "Walk",
    ExpectedDuration: 30,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6002,
    FullTitle: "Stairs",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6003,
    FullTitle: "Fall",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6004,
    FullTitle: "Help to get up from chair",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6005,
    FullTitle: "Help to get out of bed",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6006,
    FullTitle: "Two handed hoist",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6007,
    FullTitle: "Help to get into bed",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6008,
    FullTitle: "Help to sit on chair",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6009,
    FullTitle: "Move from one room to another",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6010,
    FullTitle: "Standing hoist",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6011,
    FullTitle: "Handling belt",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6012,
    FullTitle: "Elevate legs",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 6099,
    FullTitle: "Other",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 7001,
    FullTitle: "Breakfast",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7002,
    FullTitle: "Lunch",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7003,
    FullTitle: "Tea (meal)",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7004,
    FullTitle: "Snack",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7005,
    FullTitle: "Tea (drink)",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7006,
    FullTitle: "Water",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7007,
    FullTitle: "Wine",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7008,
    FullTitle: "Coffee",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7009,
    FullTitle: "Drink",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7010,
    FullTitle: "Fluid watch",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7011,
    FullTitle: "Nutrition watch",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7012,
    FullTitle: "Weigh",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7013,
    FullTitle: "Take food order to kitchen",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7014,
    FullTitle: "Ensure drink",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7015,
    FullTitle: "Fruit juice",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7016,
    FullTitle: "Blood sugar",
    ExpectedDuration: 5,
    AspectOfLifeName: "Medical",
  },
  {
    ActionIconID: 7017,
    FullTitle: "Out to eat",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7018,
    FullTitle: "Café",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7019,
    FullTitle: "Alcoholic drink",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7020,
    FullTitle: "Supper",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7021,
    FullTitle: "Thickened drink",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7022,
    FullTitle: "Milkshake",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7023,
    FullTitle: "Milk",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7024,
    FullTitle: "Hot chocolate",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7025,
    FullTitle: "Had soup",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 7099,
    FullTitle: "Other",
    ExpectedDuration: 15,
    AspectOfLifeName: "Nutrition eating and drinking",
  },
  {
    ActionIconID: 8001,
    FullTitle: "Wash",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8002,
    FullTitle: "Dressed",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8003,
    FullTitle: "Chiropodist",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8004,
    FullTitle: "Hairdresser",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8005,
    FullTitle: "Bathed",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8006,
    FullTitle: "Shower",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8007,
    FullTitle: "Cleaning",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8008,
    FullTitle: "Teeth/mouth cleaned",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8009,
    FullTitle: "Shave",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8010,
    FullTitle: "Hair wash",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8011,
    FullTitle: "Hair brush",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8012,
    FullTitle: "Finger nails",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8013,
    FullTitle: "Toe nails",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8014,
    FullTitle: "Glasses",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8015,
    FullTitle: "Hearing aid",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8016,
    FullTitle: "Make-up",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8017,
    FullTitle: "Laundry",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8018,
    FullTitle: "Bath temperature",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8019,
    FullTitle: "Catheter care",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8020,
    FullTitle: "Eye check",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8021,
    FullTitle: "Undressed",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8022,
    FullTitle: "Menstruation",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8023,
    FullTitle: "Wash hands",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8024,
    FullTitle: "Denture care",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8025,
    FullTitle: "Ear check",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 8099,
    FullTitle: "Other",
    ExpectedDuration: 15,
    AspectOfLifeName: "Personal care",
  },
  {
    ActionIconID: 9001,
    FullTitle: "Check slept",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 9002,
    FullTitle: "Check pad",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 9003,
    FullTitle: "Disturbed night",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 9004,
    FullTitle: "Rang bell",
    ExpectedDuration: 15,
    AspectOfLifeName: "Communication",
  },
  {
    ActionIconID: 9007,
    FullTitle: "Stayed in bed",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 9008,
    FullTitle: "Reposition",
    ExpectedDuration: 15,
    AspectOfLifeName: "Mobility",
  },
  {
    ActionIconID: 9090,
    FullTitle: "Acoustic monitoring",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 9099,
    FullTitle: "Other",
    ExpectedDuration: 5,
    AspectOfLifeName: "Sleeping",
  },
  {
    ActionIconID: 10001,
    FullTitle: "Shift handover",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10002,
    FullTitle: "Visit start",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10003,
    FullTitle: "Handover note",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10004,
    FullTitle: "Care suspended",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10005,
    FullTitle: "Care recommenced",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10006,
    FullTitle: "Record height",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10007,
    FullTitle: "Admitted",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10008,
    FullTitle: "Discharged",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10009,
    FullTitle: "Complaint",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10010,
    FullTitle: "Personal money",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10011,
    FullTitle: "Visit end",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10012,
    FullTitle: "Chatted with Relatives",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10013,
    FullTitle: "Manager note",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10014,
    FullTitle: "Alert",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10021,
    FullTitle: "Compliment",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10022,
    FullTitle: "Transport",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 10023,
    FullTitle: "Keyworker",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
  {
    ActionIconID: 11001,
    FullTitle: "Pendant alarm",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11002,
    FullTitle: "Check OK",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11003,
    FullTitle: "Change bed",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11004,
    FullTitle: "Check mattress",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11005,
    FullTitle: "Check chair",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11006,
    FullTitle: "Check bedrails",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11007,
    FullTitle: "Adjust curtains",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11008,
    FullTitle: "Check room",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11009,
    FullTitle: "Check room temperature",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11010,
    FullTitle: "Check action mat",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11011,
    FullTitle: "Check wheelchair",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11012,
    FullTitle: "Check wheelchair belt",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11013,
    FullTitle: "Check fridge temperature",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11014,
    FullTitle: "Check hoist sling",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 11015,
    FullTitle: "Check footware",
    ExpectedDuration: 5,
    AspectOfLifeName: "Personal safety and environment",
  },
  {
    ActionIconID: 111001,
    FullTitle: "Staff message",
    ExpectedDuration: 5,
    AspectOfLifeName: "Processes",
  },
];
